/**
 * Company news management - English (M15)
 */
export default {
  title: 'Company News',
  readonlyNotice:
    'Your account is a regular user and can only view news. Contact the tenant admin to edit.',
  searchPlaceholder: 'Search news...',
  add: 'Add News Article',
  addFirst: 'Add first article',
  drafts: 'Drafts',
  empty: 'No news yet',
  emptyDraft: 'No drafts',
  untitled: 'Untitled',
  noSummary: 'No summary',
  noDate: 'No date',
  confirmDelete: 'Delete this news article?',
  editTitle: 'Edit News Article',
  createTitle: 'Add News Article',
  previewTitle: 'News Detail',
  draftBoxTitle: 'Drafts',
  form: {
    title: 'Article Title',
    titlePlaceholder: 'e.g. 2025 Sustainability Goals',
    summary: 'Summary',
    summaryPlaceholder: 'Enter article summary (max 500 characters)',
    content: 'Article Content',
    contentPlaceholder: 'Enter your content here...',
    cover: 'Cover Image (optional)',
    coverUpload: 'Click or drag to upload',
    coverHint: 'Recommended: 1200x600px (JPG, PNG, max 5MB)'
  },
  editor: {
    body: 'Body',
    heading: 'Heading',
    linkPrompt: 'Enter link URL'
  },
  status: {
    draft: 'Draft',
    published: 'Published'
  },
  actions: {
    cancel: 'Cancel',
    saveDraft: 'Save Draft',
    publish: 'Publish Article',
    refresh: 'Refresh',
    edit: 'Edit',
    delete: 'Delete'
  },
  messages: {
    titleRequired: 'Please enter the article title',
    contentRequired: 'Please enter the article body',
    loadFail: 'Failed to load news',
    saveSuccess: 'Saved',
    saveFail: 'Save failed',
    publishSuccess: 'Published',
    deleteSuccess: 'Deleted',
    deleteFail: 'Delete failed',
    uploadTooLarge: 'Image must be 5MB or smaller',
    uploadFail: 'Cover upload failed'
  }
}
